import { Avatar, Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, Flex, Grid, Image, Input, Text, useToast } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import AddButton from '../Assets/Icons/AddButton.svg';
import profilebadge from '../Assets/Icons/profilebadge.svg';
import profilebadge2 from '../Assets/Icons/profilebadge2.svg';
import fire from '../Assets/Icons/fire.svg';
import CustomProgress from '../../common/CustomProgress';
import Resume from '../../assets/images/Resume.svg';
import { useMediaQuery } from '@chakra-ui/react';
import ProfileFields from './Profile/ProfileFields';
import { useUser, useUserProfile } from '../../../hooks/useUser';
import { useNavigate } from 'react-router-dom';
import { useStreaks } from '../../../hooks/V2/useUser';
import { useMutation, useQueryClient } from 'react-query';
import { signOut } from '../../../apis/auth';
import { AxiosError } from 'axios';
import { UIErrorResponse } from 'types/src/error';
import { Link as ReactRouter } from 'react-router-dom';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { FiEdit2 } from 'react-icons/fi';
import { ProfileImage } from './Profile/ProfileImage';
import { useDomainConfig } from '../../../hooks/useDomainConfig';
import { SAGEX_ORG_KEY } from '../../../utils/segexOrgName';

const ProfilePage = () => {
	const { data: domainConfig } = useDomainConfig({ uiHost: window.location.host });
	const toast = useToast();
	const queryClient = useQueryClient();
	const progressValue = {
		1: 0,
		2: 25,
		3: 50,
		4: 75,
	};

	const totalSteps = 4;
	const currentStep = 2;
	// Simulate progress update
	useEffect(() => {
		//
	}, [progressValue]);
	type activitiesType = {
		name: string;
		logo: string;
		desc: string;
		ext?: string;
		bg?: string;
		link?: string;
	};
	const { data: streakCount } = useStreaks();
	const { data: userProfile } = useUserProfile();

	const activities: activitiesType[] = [
		{
			name: 'Streak',
			logo: fire,
			desc: `${streakCount} day`,
			ext: 'Streak',
			bg: '#F6EDE7',
			link: '/streaks',
		},
		{
			name: 'Badges',
			logo: profilebadge2,
			desc: `${userProfile?.badges?.length} Collected`,
			bg: '#F2FDFF',
			link: '/badges',
		},
		{
			name: 'Resume',
			logo: Resume,
			desc: `0 Created`,
			bg: '#FFF9E5',
			link: '/resume',
		},
	];
	const [isLargerThan560] = useMediaQuery('(min-width: 775px)');
	const { data: user, refetch } = useUser();
	const navigate = useNavigate();

	const { mutate: signOutMutate, isLoading } = useMutation(signOut, {
		onSuccess: () => {
			if (SAGEX_ORG_KEY !== domainConfig?.key) {
				navigate('/login');
				refetch();
				queryClient.clear();
			} else {
				window.location.href = `http://sageextension.com/login`;
			}
		},
		onError: (error: AxiosError<UIErrorResponse>) => {
			toast({
				title: 'Error',
				description: error?.response?.data?.message || 'User sign out failed',
				status: 'error',
				duration: 2000,
				isClosable: true,
				position: 'top',
			});
		},
	});

	return (
		<Box bg="#F2F6FF" minH="full" pb={{ base: '100px', xl: '40px' }} pt="20px">
			{/* {!isLargerThan560 ? (
				<Flex
					onClick={() => {
						navigate('/dashboard');
					}}
					bg="#4358F6"
					padding="4px 20px 4px 16px"
					alignItems={'center'}
					gap={'8px'}
				>
					<svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 32 32" fill="none">
						<path
							d="M26.6667 14.6667V17.3333H10.6667L18 24.6667L16.1067 26.56L5.54669 16L16.1067 5.44L18 7.33334L10.6667 14.6667H26.6667Z"
							fill="white"
						/>
					</svg>
					<Text color={{ base: '#ffff', md: 'black' }} textStyle="body2-md" fontFamily="Open Sans">
						My Profile
					</Text>
				</Flex>
			) : ( */}

			<Breadcrumb px="16px" mb="20px" separator={<ChevronRightIcon boxSize="16px" color="#544D4F" />}>
				<BreadcrumbItem>
					<BreadcrumbLink
						onClick={() => {
							navigate('/dashboard');
						}}
					>
						Home
					</BreadcrumbLink>
				</BreadcrumbItem>

				<BreadcrumbItem isCurrentPage color="#4358F6">
					<BreadcrumbLink href="#">My Profile</BreadcrumbLink>
				</BreadcrumbItem>
			</Breadcrumb>

			<Text display={{ base: 'none', md: 'block' }} px="16px" textStyle="h3" color="#0A0103">
				My Profile
			</Text>
			{/* )} */}

			<Flex
				direction={{ base: 'column', md: 'row' }}
				gap={'16px'}
				alignItems={'center'}
				justifyContent={{ base: 'center', md: 'start' }}
				mt={'32px'}
				ml={{ base: '', md: '24px' }}
			>
				<Box position={'relative'}>
					{/* <Avatar size="xl" name="Debobrota Haldar" src="" /> */}

					<Avatar
						size="xl"
						bg="#D6E2FA"
						color="#3470E4"
						name={user?.name}
						fontWeight="bold"
						// icon={<FiEdit2 fontSize="1.3rem" color={"#5a8aef"} />}
					/>

					{/* <ProfileImage/> */}

					{/* <Image src={AddButton} alt={'addButton'} position={'absolute'} bottom={'1'} right={'1'} /> */}
				</Box>
				<Flex direction={'column'} alignItems={'flex-start'} w={{ base: '', md: '100%' }}>
					<Text color={'#0A0103'} as="h5" fontFamily={'Poppins'} fontSize={'18px'} fontWeight={'700'} lineHeight={'24px'}>
						{user?.name}
					</Text>
					{/* {isLargerThan560 && (
						<Flex
							border={'1.4px solid #3470E4'}
							borderRadius={'8px'}
							bg={'#fff'}
							padding={'12px'}
							alignItems={'center'}
							gap={'8px'}
							m={{ base: '24px', md: '0' }}
							mt={{ base: '0', md: '8px' }}
							w={'50%'}
						>
							<Image src={profilebadge} alt={'profilebadge'} w={'32px'} h={'31px'} flexShrink={'0'} />
							<Flex direction={'column'} gap={'5px'} w={'100%'}>
								<Text color={'#4358F6'} fontFamily="Open Sans" fontSize="14px" fontStyle="normal" fontWeight="600" lineHeight="24px">
									Complete your profile
								</Text>
								<Box w={'100%'} position={'relative'} mt={'0'}>
									<Text
										color="#0A0103"
										textAlign="right"
										fontFamily="Inter"
										fontSize="10px"
										fontStyle="normal"
										fontWeight="500"
										lineHeight="10px"
										position={'absolute'}
										right={'0'}
										bottom={'3'}
									>
										{(currentStep / totalSteps) * 100}%
									</Text>
									<CustomProgress value={progressValue[currentStep]} max={50} />
								</Box>
							</Flex>
						</Flex>
					)} */}
				</Flex>
			</Flex>
			{/* {!isLargerThan560 && (
				<Flex
					border={'1.4px solid #3470E4'}
					borderRadius={'8px'}
					bg={'#fff'}
					padding={'12px'}
					alignItems={'center'}
					gap={'8px'}
					m={'24px'}
					mt={'12px'}
				>
					<Image src={profilebadge} alt={'profilebadge'} w={'32px'} h={'31px'} flexShrink={'0'} />
					<Flex direction={'column'} gap={'5px'} w={'100%'}>
						<Text color={'#4358F6'} fontFamily="Open Sans" fontSize="14px" fontStyle="normal" fontWeight="600" lineHeight="24px">
							Complete your profile
						</Text>
						<Box w={'100%'} position={'relative'} mt={'0'}>
							<Text
								color="#0A0103"
								textAlign="right"
								fontFamily="Inter"
								fontSize="10px"
								fontStyle="normal"
								fontWeight="500"
								lineHeight="10px"
								position={'absolute'}
								right={'0'}
								bottom={'3'}
							>
								{(currentStep / totalSteps) * 100}%
							</Text>
							<CustomProgress value={progressValue[currentStep]} max={50} />
						</Box>
					</Flex>
				</Flex>
			)} */}
			{SAGEX_ORG_KEY !== domainConfig?.key && (
				<Box m={'16px'} mt="32px">
					<Text color={'#0A0103'} as="h5" fontFamily={'Poppins'} fontSize={'18px'} fontWeight={'700'} lineHeight={'24px'}>
						My Activities
					</Text>
					<Flex flexWrap={'wrap'} gap={6} mt={'12px'}>
						{activities?.map((el, index) => (
							<Box
								to={el.link}
								as={ReactRouter}
								cursor="pointer"
								key={index}
								display="flex"
								padding="16px"
								flexDirection="column"
								justifyContent="center"
								alignItems="center"
								gap="10px"
								flexShrink="0"
								borderRadius="12px"
								bg={el.bg}
								boxShadow="0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)"
							>
								<Text color={'#0A0103'} textAlign={'center'} textStyle={{ base: 'body1-md', md: 'h6' }}>
									{el.name}
								</Text>
								<Flex alignItems={'center'} gap={'8px'}>
									<Box>
										<Image src={el.logo} alt="fire" h={'32px'} w={'32px'} />
									</Box>
									<Text color={'#0A0103'} textStyle="body1-md" textAlign={'center'}>
										{el.desc}
									</Text>
									<Text fontSize="12px" fontStyle="normal" fontWeight="500" lineHeight="16px" color={'#3B3435'} ml={'-1'}>
										{el.ext}
									</Text>
								</Flex>
							</Box>
						))}
					</Flex>
				</Box>
			)}

			<Box px="16px" mt="32px">
				<Text color={'#0A0103'} as="h5" fontFamily={'Poppins'} fontSize={'18px'} fontWeight={'700'} lineHeight={'24px'}>
					Profile Details
				</Text>
				<ProfileFields />
			</Box>

			<Box px="16px">
				<Button
					mt="20px"
					w={{ base: 'full', md: 'fit-content' }}
					boxShadow="1px 1px red"
					color="red"
					colorScheme="red"
					isLoading={isLoading}
					onClick={() => {
						signOutMutate();
					}}
					variant="tertiary"
				>
					Logout
				</Button>
			</Box>
		</Box>
	);
};

export default ProfilePage;
